<template>
  <router-view></router-view>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";

export default {
  created() {
    Vue.use(VModal, {
      dialog: true
    });
  }
};
</script>
